<template>
    <v-row>
        <v-col cols="12" sm="6" md="4">
            <v-list>
                 <show-field :value="item.name" :label="$t('delivery.productCategory.labels.name')" icon="title"/>
                 <show-field :value="item.fontColor" :label="$t('delivery.productCategory.labels.fontColor')" icon="format_color_text"/>
            </v-list>
        </v-col>

        <v-col cols="12" sm="6" md="4">
            <v-list>
                 <show-field :value="item.backgroundColor" :label="$t('delivery.productCategory.labels.backgroundColor')" icon="palette"/>
                 <show-field :value="String(item.surcharge)" :label="$t('delivery.productCategory.labels.surcharge')" icon="price_change"/>
            </v-list>
        </v-col>

        <v-col cols="12" sm="6" md="4">
            <v-list>
                 <show-field :value="item.borderColor" :label="$t('delivery.productCategory.labels.borderColor')" icon="format_color_fill"/>
              <show-field :value="String(item.homeGallery)" :label="$t('delivery.product.labels.homeGallery')" icon="home"/>

            </v-list>
        </v-col>

    </v-row>
</template>
<script>
    import {ShowField} from '@dracul/common-frontend'


    export default {
        name: 'ProductCategoryShowData',
        components: {ShowField},

        props: {
            item: {type: Object, required: true}
        }
    }
</script>

